import { useMemo } from 'react';
import { getPlatform } from '@/utils/nativePlugins';

/**
 * Platform-aware safe area insets hook.
 * 
 * Android 15+ enforces edge-to-edge display, meaning CSS environment
 * variables for safe area insets are now correctly reported. This hook
 * applies safe area padding on all platforms including Android.
 */
export const useSafeAreaInsets = () => {
  const platform = getPlatform();
  
  return useMemo(() => {
    const isAndroid = platform === 'android';
    
    return {
      // CSS classes for Tailwind - applied on ALL platforms
      topPadding: 'pt-[env(safe-area-inset-top)]',
      bottomPadding: 'pb-[env(safe-area-inset-bottom)]',
      topMargin: 'mt-[env(safe-area-inset-top)]',
      bottomMargin: 'mb-[env(safe-area-inset-bottom)]',
      
      // For calc-based classes
      topInsetValue: 'env(safe-area-inset-top)',
      bottomInsetValue: 'env(safe-area-inset-bottom)',
      
      // Platform for conditional logic
      platform,
      isAndroid,
    };
  }, [platform]);
};
